import { NamespacesStorageObject } from '../types/namespaces-storage-object'

export const newNamespacesStorageObject = (): NamespacesStorageObject => ({
  timestamp: Date.now(),
  namespaces: {},
})
